import type { PostHogConfig } from "posthog-js"
import { PostHogProvider } from "posthog-js/react"
import { memo } from "react"

interface PostHogProps {
	children: React.ReactNode
}

const posthogConfigOptions: Partial<PostHogConfig> = {
	api_host: "https://us.i.posthog.com",
	// TODO: useAppSelector(selectAutoCapture) -- see corresponding TODO in MainAppView.tsx
	autocapture: true,
	debug: import.meta.env.NODE_ENV === "development",
}

export const PostHog = memo((props: PostHogProps) => {
	const { children } = props
	// TODO: const userHasConsented = useAppSelector(selectUserHasConsentedToTracking)
	const enablePostHog = ["1", "true"].includes(import.meta.env.REACT_APP_USE_POSTHOG ?? "1")

	if (enablePostHog) {
		return (
			// TODO: Lazy-load PostHogProvider
			<PostHogProvider apiKey={import.meta.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={posthogConfigOptions}>
				{children}
			</PostHogProvider>
		)
	}
	return <>{children}</>
})

PostHog.displayName = "PostHog"
